import {
  Box,
  Flex,
  Image,
  Button,
  Stack,
  Text,
  useDisclosure,
  useMediaQuery,
  useColorMode,
} from "@chakra-ui/react";
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
import Logo from "./images/dummy.gif";
import AnchorLink from "react-anchor-link-smooth-scroll";
import ToggleColorMode from "./ToggleColorMode";
import cv from "./images/Prince_Singh_Resume_new.pdf"
import { useState } from "react";

const Navbar = () => {
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const hoverColor = "#0768F8";

  const { isOpen, onOpen, onClose } = useDisclosure();
  const goto = ()=>{
    window.open("https://drive.google.com/file/d/142LD5wD4ruf4Mo2np9CKQweA5s0GbBE0/view?usp=sharing")
  }
  return (
    <Box w="100%"  position="fixed"  background="white" zIndex="1">
    <Flex justify="space-between"  align="center">
      <Flex
        box-shadow="rgba(0, 0, 0, 0.4) 0px 30px 90px"
        align="center"
        gap="1.5rem"
        ml="1rem"
      >
        <AnchorLink  href="#Home">
          <Image
          _hover={{
            border:"none",
            textDecoration: "none" ,
            transitionDuration: "1000ms",
            transform:"scale(1.1)",
            cursor:"pointer",
          
          }}
            width="100px"
            height="70px"
            borderRadius={50}
            src={Logo}
            alt="WebTaskIt.com"
          />
        </AnchorLink>
        {isLargerThan768 ? (
          <>
            <Stack
             
              direction="row"
              spacing={8}
              justifyContent={"center"}
              alignItems={"center"}
              fontSize={18}
              fontWeight={"500"}
            >
              <AnchorLink href="#Home">
              <Text
             
              cursor="pointer"
              textDecoration="none"
              
              _hover={{ textDecorationStyle: "line" }}
              color="black"
              fontFamily="Serif" 
  >
    Home
  </Text>
              </AnchorLink>
              <AnchorLink href="#About">
                <Text
                  cursor="pointer"
                  textDecoration="none"
                  color="black"
                  fontFamily="Serif" 
                >
                  About 
                </Text>
              </AnchorLink>
              <AnchorLink href="#Skills">
                <Text
                  cursor="pointer"
                  textDecoration="none"
                  color="black"
                  fontFamily="Serif"  
                >
                  Skills
                </Text>
              </AnchorLink>
              <AnchorLink href="#Project">
                <Text
                  cursor="pointer"
                  textDecoration="none"
                  color="black"
                  fontFamily="Serif" 
                >
                  Project
                </Text>
              </AnchorLink>
              <AnchorLink href="#Contact">
                <Text
                  cursor="pointer"
                  textDecoration="none"
                  color="black"
                  fontFamily="Serif" 
                >
                  Contact
                </Text>
              </AnchorLink>
              <a  download
                  _hover={{ textDecoration: "none" }}
                  href={cv}
                  
                >
              <Button 
              _hover={{
                transform: "scale(1.05)",
                transition: "transform, 0.5s",
              }}
              colorScheme='linkedin'
                onClick={goto}
                p={["10px", "25px", "10px"]}
                mt="25px"
                fontSize={["lg", "xl", "2xl"]}
                mb="25px"
              >
                  Resume
             
              </Button>
              </a>
              <Text
                cursor="pointer"
                _hover={{
                  color: hoverColor,
                  textDecoration: "underline",
                }}
              >
                <ToggleColorMode />
              </Text>
            </Stack>
          </>
        ) : null}
      </Flex>

      <Flex
        display={["none", "none", "flex", "flex"]}
        justify="space-between"
        align="center"
        gap="1.5rem"
        mr="1rem"
      >
        <Box display="flex" alignItem="center"></Box>
      </Flex>

      <Box
        display={["inline-block", "inline-block", "none", "none"]}
        mr="2rem"
      >
        <GiHamburgerMenu onClick={onOpen} color="black"
                  fontFamily="Serif"  size="1.5rem" />
      </Box>
      {/* Hamburger menu bar */}
      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>HomePage</DrawerHeader>
          <DrawerBody>
            {/* <Box m="25px auto" fontSize={18} fontWeight={"500"}>
                <Text _hover={{ color: "blue", cursor: "pointer" }}>
                  Products {">"}
                </Text>
              </Box> */}

            <Box  m="25px auto" fontSize={18} fontWeight={"500"} >
              <AnchorLink href="#Home" isOpen={isOpen} onClose={onClose} placement="right">
                <Text
                  cursor="pointer"
                  color="black"
                  fontFamily="Serif" 
                 
                >
                  Home
                </Text>
              </AnchorLink>
            </Box>
            <Box m="25px auto" fontSize={18} fontWeight={"500"}>
              <AnchorLink href="#About">
                <Text
                  cursor="pointer"
                  color="black"
                  fontFamily="Serif" 
                >
                  About Me
                </Text>
              </AnchorLink>
            </Box>
            <Box m="25px auto" fontSize={18} fontWeight={"500"}>
              <AnchorLink href="#Skills">
                <Text
                  cursor="pointer"
                  color="black"
                  fontFamily="Serif" 
                >
                  Skills
                </Text>
              </AnchorLink>
            </Box>

            <Box m="25px auto" fontSize={18} fontWeight={"500"}>
              <AnchorLink href="#Project">
                <Text
                  cursor="pointer"
                  color="black"
                  fontFamily="Serif" 
                >
                  Project
                </Text>
              </AnchorLink>
            </Box>

            <Box m="25px auto" fontSize={18} fontWeight={"500"}>
              <AnchorLink href="#Contact">
                <Text
                  cursor="pointer"
                  color="black"
                  fontFamily="Serif" 
                >
                  Contact
                </Text>
              </AnchorLink>
            </Box>
            <Box m="25px auto" fontSize={18} fontWeight={"500"}>
              <Button
              colorScheme='linkedin'
              onClick={goto}
                p={["10px", "25px", "10px"]}
                mt="25px"
                fontSize={["lg", "xl", "2xl"]}
                mb="25px"
              >
              <a   >
                <a
                  href={cv}
                  _hover={{ textDecoration: "none" }}
                  download
                  target="_blank"
                >
                  Resume
                </a>
                </a>  
              </Button>
            </Box>
            <Box m="25px auto" fontSize={18} fontWeight={"500"}>
              <Link to={""}>
                <ToggleColorMode />
              </Link>
            </Box>

            <Box m="25px auto"></Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  </Box>
  );
};

export default Navbar;
